import React from 'react';
import { useAlert } from '../../contexts/alerta';
import { FaTriangleExclamation,
  FaCircleExclamation,
  FaCircleCheck,
  FaCircleXmark
 } from 'react-icons/fa6';

const alertStyles = {
  info: 'bg-primary bg-opacity-50 text-primary',
  success: 'bg-sucess bg-opacity-50 text-sucess',
  warning: 'bg-danger bg-opacity-50 text-danger',
  error: 'bg-warning  bg-opacity-50 text-warning',
};

const iconAlert = (type) => {
  switch(type){
    case 'success':
      return <FaCircleCheck/>
    case 'warning':
      return <FaTriangleExclamation/>
    case 'info':
      return <FaCircleExclamation />
    case 'error':
      return <FaCircleXmark/>
    default:
      return null;
  }
}

const Alert = () => {
  const { alerts, removeAlert } = useAlert();

  return (
    <div className="fixed bottom-10 right-10 min-w-[30vw] z-50 space-y-4 ">
      {alerts.map(alert => (
        <div
          key={alert.id}
          className={`p-4 rounded shadow-lg flex justify-between items-center ${alertStyles[alert.type]}`}
        >
          {iconAlert(alert.type)}
          <span>{alert.message}</span>
          <button className="ml-4 font-bold" onClick={() => removeAlert(alert.id)}>
            X
          </button>
        </div>
      ))}
    </div>
  );
};

export default Alert;